// Dependencias
import Api from '@/services/Api'
// methods
export default {
  fetch (token) {
    return Api().get('transactionsEducational', {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  fetch2 (token) {
    return Api().get('transactionsEducational2', {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  editTransaction (params, token) {
    return Api().put('transactionsEducational/' + params.archive_id, params, {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  }
}



// WEBPACK FOOTER //
// ./src/services/TransactionsEducationalService.js